export const updateProgress = (setProgress) => {
  setProgress((prevProgress) => prevProgress + 1);
};
